import { render } from "./stockList.vue?vue&type=template&id=cfa9056a&scoped=true"
import script from "./stockList.vue?vue&type=script&lang=js"
export * from "./stockList.vue?vue&type=script&lang=js"

import "./stockList.vue?vue&type=style&index=0&id=cfa9056a&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa9056a"]])

export default __exports__